import _ from "lodash";


export function cartesianProduct(a) { // a = array of array
    var i, j, l, m, a1, o = [];
    if (!a || a.length === 0) return a;

    a1 = a.splice(0, 1)[0].sort(); // the first array of a
    a = cartesianProduct(a);
    for (i = 0, l = a1.length; i < l; i++) {
        if (a && a.length)
            for (j = 0, m = a.length; j < m; j++)
                o.push([a1[i]].concat(a[j]));
        else
            o.push([a1[i]]);
    }
    return o;
}

export const generatePeriods = (inputString) => {
    const output = { max: 0, step: 0 };
    const marks = {};
    if (inputString.length > 0) {
        let max = 0;
        if (inputString.length > 1) {
            let step = 1;

            for (let i = 0; i < inputString.length; i++) {
                const key = i;
                const value = inputString.charAt(i);
                marks[key] = value;
                max = key;
            }
            output.max = max;
            output.step = step;
            output.marks = marks;
            output.empty = false
        } else {
            output.marks = { 0: inputString }
            output.step = 0;
            output.max = max;
            output.empty = false
        }
    } else {
        output.marks = {};
        output.max = 0;
        output.step = 0;
        output.empty = true
    }
    return output;
}

export const generateDataTimeDimensionTable = (periodType) => {
    switch (periodType) {
        case 'S': {
            return [
                { key: 'B1', sdmxPeriod: 'B1', localPeriod: '' },
                { key: 'B2', sdmxPeriod: 'B2', localPeriod: '' }
            ];
        }
        case 'Q': {
            return [
                { key: 'Q1', sdmxPeriod: 'Q1', localPeriod: '' },
                { key: 'Q2', sdmxPeriod: 'Q2', localPeriod: '' },
                { key: 'Q3', sdmxPeriod: 'Q3', localPeriod: '' },
                { key: 'Q4', sdmxPeriod: 'Q4', localPeriod: '' },
            ];
        }
        case 'M': {
            const months = Array.from({ length: 12 }, (_, i) => {
                const month = (i + 1).toString().padStart(2, '0');
                return { key: month, sdmxPeriod: month, localPeriod: '' };
            });
            return months;
        }
        default:
            return []
    }
};

export const generateDataTimeDimensionTableEdit = (periodRules) => {
    return periodRules.map((value) => ({
        key: value.periodId,
        sdmxPeriod: value.periodId,
        localPeriod: value.localCode,
        [value.periodId]: value.localCode
    }));
};


export const generateDataToSaveTranscoding = (data, dataTable) => {
    let obj = {
        transcodingEntityId: !!data.transcoding ? data.transcoding.transcodingEntityId : null,
        componentMappingEntityId: data.entityId,
        timeTranscodings: null,
        rules: []
    }
    
    let rowsWithComponent = _.filter(dataTable, (row) => row.Component)

    for (let i = 0; i < rowsWithComponent.length; i++) {
        obj.rules.push({
            uncodedValue: null,
            code: {
                dataSetColumnEntityName: rowsWithComponent[i]['Component'].Code,
                dataSetColumnParentId: null
            },
            localCodes: _.keys(_.omit(rowsWithComponent[i], ['key', 'Component'])).map(e =>
                _.assign({}, ({
                    dataSetColumnEntityName: rowsWithComponent[i][e],
                    dataSetColumnParentId: _.find(data.dataset_column, { name: e }).name
                }))
            )
        })
    }
    return obj
}

export const generateDataToGetTranscoding = (response, data, columnCodelist, tableCartesian) => {
    const { rules } = response
    const { dataset_column } = data
    const dataTable = []
    for (let i = 0; i < rules.length; i++) {
        dataTable.push({
            key: i,
            ...(_.times(rules[i].localCodes.length, (p) => ({
                [`${_.find(dataset_column, { name: rules[i].localCodes[p].dataSetColumnParentId }).name}`]:
                    rules[i].localCodes[p].dataSetColumnEntityName
            })).reduce((a, b) => ({ ...a, ...b }))),
            Component: _.find(columnCodelist, { Code: rules[i].code.dataSetColumnEntityName })
        })
    }
    tableCartesian.forEach((item, idx) => {
        const relevantKeys = Object.keys(item).filter(key => key !== "key" && key !== "Component");
        const matchingDataTableRow = dataTable.find(row => relevantKeys.reduce((acc, curr) => acc && row[curr] === item[curr], true));
        if (!matchingDataTableRow) {
            dataTable.splice(idx, 0, item);
            return;
        }
        if (matchingDataTableRow.key !== item.key) matchingDataTableRow.key = item.key;
    });
    return dataTable;
}


export const arraySubstrings = (columnName, datasetValue, value) => {
    const dataString = datasetValue.filter((item) => item.column === columnName).map((res) => res.values)[0]
    const result = dataString ? dataString.map((item) => {
        const subString = item.slice(value[0], value[1] + 1);
        return subString;
    }) : []
    return result
}

export const getNewCard = () => ({
    frequency: null,
    optionYearColumn: null,
    optionPeriodColumn: null,
    dataTable: [],
    periodMarks: {
        marks: {
            0: '-'
        },
        step: 0,
        max: 0
    },
    yearMarks: {
        marks: {
            0: '-'
        },
        step: 0,
        max: 0
    },
    yearSlider: null,
    periodSlider: null,
    yearData: null,
    periodData: null,
});

export const getColumnValue = (selectedDataset,
                               selectedConnection,
                               data) => (
    {
        columnName: selectedDataset.name,
        connId: selectedConnection.entityId,
        limit: 1,
        page: 0,
        searchText: "",
        query: selectedDataset.query,
        columns: data.columnName
    }
);

export const validateTimeDimensionInputs = (item) => {
    let errors = [];
    if (!item.frequency) {
        errors.push("frequency");
    }
    if (!item.optionYearColumn) {
        errors.push("selectYear");
    }
    if (item.frequency !== 'A' && !item.optionPeriodColumn) {
        errors.push("optionPeriodColumn");
    }
    if (item.optionYearColumn && item.optionPeriodColumn) {
        if (item.periodMarks.empty) {
            errors.push("empty");
        }
    } else {
        if (item.yearMarks.empty) {
            errors.push("empty");
        }
    }
    if (item.dataTable && item.dataTable.length > 0) {
        if (!item.dataTable.some(item => (item.localPeriod).trim() !== ""))
            errors.push("dataTable");
    }
    return errors.length === 0;
};

export const validateErrorsByInput = (index, key, value, cards, isFreqChanged, columnData, inputErrors) => {
    const updatedCards = [...cards];
    let valueSlider = [0, 0];
    if (isFreqChanged) {
        return {...inputErrors, [`localPeriod_${key}`]: 'error'};
    } else {
        if (updatedCards[index].optionPeriodColumn || updatedCards[index].optionYearColumn) {
            valueSlider = updatedCards[index].optionPeriodColumn ? updatedCards[index].periodSlider : (updatedCards[index].optionYearColumn ? updatedCards[index].yearSlider : [0, 0]);
            const selectedPeriod = (valueSlider[1] - valueSlider[0]) + 1;
            const subsStrings = arraySubstrings(updatedCards[index].optionPeriodColumn ? updatedCards[index].optionPeriodColumn : updatedCards[index].optionYearColumn, columnData, valueSlider)
            if ((value.length > selectedPeriod) || !value) {
                return {...inputErrors, [`localPeriod_${key}`]: 'error'};
            } else {
                if (subsStrings && subsStrings.some(val => val.includes(value))) {
                    return {...inputErrors, [`localPeriod_${key}`]: ''};
                } else {
                    return {...inputErrors, [`localPeriod_${key}`]: 'error'};
                }
            }
        }
    }

    return inputErrors;
};

export const validateErrorsByCards = (cards, isFreqChanged, columnData, inputErrors) => {
    const newInputErrors = {};
    cards.forEach((card, index) => {
        card.dataTable && card.dataTable.forEach((record) => {
            const updatedErrors = validateErrorsByInput(index, record.key, record.localPeriod, cards, isFreqChanged, columnData, inputErrors);
            newInputErrors[`localPeriod_${record.key}`] = updatedErrors[`localPeriod_${record.key}`];
        });
    });
    return newInputErrors;
};